// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancel-btn :hover{
    background-color:#666 !important;
}

:host ::ng-deep .p-datatable > .p-datatable-wrapper {
    overflow: unset; 
}`, "",{"version":3,"sources":["webpack://./src/app/features/mappingselection/mappingselection.component.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".cancel-btn :hover{\r\n    background-color:#666 !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable > .p-datatable-wrapper {\r\n    overflow: unset; \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
